import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Text, View } from '@olxbr/design-system'

const Content = styled(View)`
  width: 100%;
  position: relative;
  border-style: solid;
  border-width: 0;
  border-top-width: 1px;
  border-color: var(--color-neutral-90);
`

const Title = styled(Text)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #898989;
  background-color: #ffffff;
  padding: 8px;
`

const ruleWithText = props => (
  <Content {...props}>{props.text && <Title>{props.text}</Title>}</Content>
)

ruleWithText.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.string,
}

ruleWithText.defaultProps = {
  color: '#f2f2f2',
}

export default ruleWithText
